import { privateAPI } from "@/shared/lib";
import type { ServiceResponse } from "@/shared/lib/axios";
import type { HealthieForm, HealthieFormParams } from "../models";

export const getHealthieFormFields = async (params: HealthieFormParams) => {
  const { data } = await privateAPI.get<ServiceResponse<HealthieForm>>(
    "/forms",
    { params },
  );

  return data.data;
};

type FieldValues = Record<string, string | string[]>;
interface SubmitField {
  value: string | string[] | undefined;
  fieldId: string;
}

export const parseFormFields = (params: FieldValues): SubmitField[] => {
  return Object.keys(params).map((key) => ({
    value: Array.isArray(params[key]) ? params[key].join("\n") : params[key],
    fieldId: key,
  }));
};

export interface SubmitFormParams {
  formId: HealthieForm["formId"];
  productId: HealthieFormParams["productId"];
  answers: Record<string, string | string[]>;
}

export const submitHealthieForm = async ({
  answers,
  ...params
}: SubmitFormParams) => {
  const { data } = await privateAPI.post<ServiceResponse<unknown>>(
    "/forms",
    {
      ...params,
      answers: parseFormFields(answers),
    },
    { headers: { "Content-Type": "multipart/form-data" } },
  );

  return data.data;
};
